<template>
  <!--
    	作者：gmshop
    	时间：2020-06-20
    	描述：diy组件-参数设置-顶部设置栏
    -->
  <div>
    <div class="common-form">
      <span>{{ curItem.name }}</span>
    </div>
    <el-form size="small" :model="curItem" label-width="100px">
      <!--页面标题-->
      <el-form-item label="页面标题：">
        <el-input v-model="curItem.params.title"></el-input>
        <p class="gray">小程序端顶部显示的标题</p>
      </el-form-item>
      <!--页面名称-->
      <el-form-item label="页面名称：">
        <el-input v-model="curItem.params.name"></el-input>
        <p class="gray">页面名称仅用于后台查找</p>
      </el-form-item>
      <!--分享标题-->
      <el-form-item label="分享标题：">
        <el-input v-model="curItem.params.share_title"></el-input>
        <p class="gray">小程序端转发时显示的标题</p>
      </el-form-item>
      <!--文字颜色-->
      <el-form-item label="文字颜色：">
        <el-radio-group v-model="curItem.style.titleTextColor">
          <el-radio :label="'black'">黑色</el-radio>
          <el-radio :label="'white'">白色</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 背景颜色 -->
      <el-form-item label="背景颜色：">
        <div class="d-s-c">
          <el-color-picker v-model="curItem.style.titleBackgroundColor"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;" @click.stop="$parent.onEditorResetColor(curItem.style, 'titleBackgroundColor', '#ffffff')">重置</el-button>
        </div>
      </el-form-item>
      <el-form-item label="小程序分享封面：">
      
        <el-button icon="el-icon-picture-outline"  @click="$parent.onEditorSelectImage(curItem.params, 'share_image')">
          选择图片
        </el-button>
        <div v-if="curItem.params.share_image !== ''" class="img item mt10">
          <img :src="curItem.params.share_image" width="100" height="100" alt="poster"/>
        </div>
        <div class="gray">建议尺寸：500px *400px </div>
    </el-form-item>
    </el-form>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },
    props: ['curItem', 'selectedIndex', 'opts'],
    created() {
      
    },
    methods: {

    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/Setpages.vue